import { render, staticRenderFns } from "./ShowMoreView.vue?vue&type=template&id=349cf864&scoped=true&"
import script from "./ShowMoreView.vue?vue&type=script&lang=ts&"
export * from "./ShowMoreView.vue?vue&type=script&lang=ts&"
import style0 from "./ShowMoreView.vue?vue&type=style&index=0&id=349cf864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349cf864",
  null
  
)

export default component.exports